@import '../../scss/mixin';

.trigger {
  @include btn();
  transition: ease-in-out 350ms;
  transition-property: opacity;
  pointer-events: auto;
}

.icon {
  width: 32px;
  height: 32px;
  background-image: url("https://design.wslabs.it/llm-ernestomeda-test/assets/trigger.gif");
  background-size: 100%;
  background-repeat: no-repeat;
}
